/* eslint-disable react/jsx-no-target-blank */
import { NoSsr } from '@cian/react-utils';
import { IconImage16, Image } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './MainImage.css';
import { trackImageLinkClick } from './trackings';
import { EStatus } from '../../types/filters';
import { IPageState } from '../../types/page';
import { IFavoriteEntity } from '../../types/results';
import { TUser } from '../../types/user';
import { getDeletedDateString } from '../../utils/favoriteEntity';
import { Text } from '../Text';

export interface IMainImageStoreProps {
  page: IPageState;
  user: TUser;
  total: number;
  favoriteEntities: IFavoriteEntity[];
}

export interface IMainImageOwnProps {
  favoriteEntity: IFavoriteEntity;
}

export type TMainImage = IMainImageStoreProps & IMainImageOwnProps;

export function MainImage(props: TMainImage) {
  const {
    favoriteEntity: {
      fullUrl,
      photoPreviewUrl,
      photoFullUrl,
      status,
      deleteDate,
      entityId,
      isCianPartner,
      externalOfferUrl,
    },
    favoriteEntities,
    page,
    user,
    total,
  } = props;

  const href = isCianPartner ? (externalOfferUrl as string) : fullUrl;
  const hasImage = photoPreviewUrl || photoFullUrl;

  return (
    <div className={styles['container']}>
      <a
        href={href}
        target="_blank"
        onClick={() => {
          trackImageLinkClick(page, user, entityId, favoriteEntities, total);
        }}
      >
        {hasImage ? (
          <Image
            src={photoPreviewUrl || photoFullUrl || ''}
            width={262}
            height={226}
            alt="Главное фото объявления"
            objectFit="cover"
          />
        ) : (
          <div className={styles['empty_photo']}>
            <IconImage16 color="gray20_100" />
          </div>
        )}
      </a>
      {status && status !== EStatus.Published && (
        <div className={styles['overlay']} data-testid="status_text">
          <div className={styles['text']}>
            <Text bold={true}>
              Объявление
              <br />
              снято с публикации
            </Text>
            {deleteDate && (
              <NoSsr>
                <Text textSize="small" color="black" data-testid="delete_date">
                  Объявление в избранном
                  <br />
                  хранится 90 дней,
                  <br />и будет удалено {getDeletedDateString(deleteDate)}
                </Text>
              </NoSsr>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
